export default __webpack_public_path__ + "static/media/register_contrata.01e1405f.png";